import { Component, Inject, Input, OnDestroy } from '@angular/core';

import { consts } from '@src/constants/consts';
import { Store } from '@src/store';
import { DialogManagerService, SessionService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { packagesActions } from '@src/store/reducers/packagesReducer';
import { AddExceptionDialogData } from '@app/shared/components/dialogs';

import moment from 'moment';
import _ from 'lodash';

@Component({
    selector: 'package-exceptions',
    template: require('./package-exceptions.component.html'),
    styles: [require('./package-exceptions.component.scss')]
})
export class PackageExceptionsComponent implements OnDestroy {
    @Input() public selectedPackage: any;
    @Input() public projectId: any;

    private onSelectedPackageEvent: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private sessionService: SessionService,
        private translatePipe: TranslatePipe,
        @Inject('$scope') $scope: any) {
        const selectedPackageEvent = consts.emitedEventsTypes.selectedPackageEvent;
        this.onSelectedPackageEvent = $scope.$on(selectedPackageEvent, (__: any, data: any) => {
            this.selectedPackage.exclusions = _.cloneDeep(data.packageExclusions);
            const exceptionTypes = this.getExceptionTypes();
            _.each(this.selectedPackage.exclusions, (exclusion: any) => {
                const exceptionType = exceptionTypes.find(exceptionType => exceptionType.id === exclusion.type);
                if (exceptionType) {
                    exclusion.name = exceptionType.name;
                }
                exclusion.creationDate = moment.utc(exclusion.creationDate).local().format('DD/MM/YYYY HH:mm:ss');
            });
            this.selectedPackage.isUserExclusionsAuthorized = data.isUserExclusionsAuthorized;
        });
    }

    public ngOnDestroy() {
        this.onSelectedPackageEvent();
    }

    public async onRemoveException(exceptionTypeId: any, exceptionTypeName: any, isUserExclusionsAuthorized: any) {
        const translations = await this.translatePipe
            .transform(['ERROR', 'ERROR_PACKAGE_EXCEPTION_FAILED_SAVE', 'ERROR_USER_AUTH']);
        if (isUserExclusionsAuthorized) {
            const onConfirm = () => {
                this.store.dispatch({
                    type: packagesActions.DELETE_PACKAGE_EXCLUSION,
                    payload: { projectId: this.projectId, packageId: this.selectedPackage.id, typeId: exceptionTypeId },
                    callback: (response: any) => {
                        if (response.status === 200 && response.data) {
                            this.selectedPackage.exclusions = _.filter(
                                this.selectedPackage.exclusions,
                                (exclusion: any) => exclusion.type !== exceptionTypeId);
                        } else {
                            this.dialogManagerService.showErrorDialog({
                                title: translations['ERROR'],
                                text: translations['ERROR_PACKAGE_EXCEPTION_FAILED_SAVE']
                            });
                        }
                    }
                });
            };
            const dialogData = {
                title: 'Delete Exception',
                action: 'delete',
                objectType: 'exception',
                item: exceptionTypeName
            };
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
        } else {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_USER_AUTH']
            });
        }
    }

    public async onNewOrEditException(edit: any, isUserExclusionsAuthorized: any) {
        let exceptionTypeslisted = [];
        const translations = await this.translatePipe.transform(['ERROR',
            'ERROR_PACKAGE_EXCEPTION_FAILED_SAVE', 'ERROR_PACKAGE_EXCEPTION_EMPTY', 'ERROR_USER_AUTH']);
        if (isUserExclusionsAuthorized) {
            if (this.selectedPackage.exclusions && this.selectedPackage.exclusions.length > 0) {
                _.each(this.getExceptionTypes(), (type: any) => {
                    const locatedItem = _.find(
                        this.selectedPackage.exclusions,
                        (exception: any) => exception.type === type.id);
                    if (!locatedItem) {
                        exceptionTypeslisted.push(type);
                    }
                });
            } else {
                exceptionTypeslisted = this.getExceptionTypes();
            }
            if (exceptionTypeslisted.length > 0) {
                const dialogData: AddExceptionDialogData = {
                    title: edit ? 'Edit Exception' : 'Add New Exception',
                    exceptionTypes: exceptionTypeslisted,
                    selectedExceptionType: exceptionTypeslisted[0]
                };
                const onConfirm = (data: AddExceptionDialogData) => {
                    if (!edit) {
                        this.store.dispatch({
                            type: packagesActions.ADD_PACKAGE_EXCLUSION,
                            payload: {
                                projectId: this.projectId,
                                packageId: this.selectedPackage.id,
                                typeId: data.selectedExceptionType.id
                            },
                            callback: (response: any) => {
                                if (response.status === 200 && response.data) {
                                    const userData = this.sessionService.user;
                                    this.selectedPackage.exclusions.push({
                                        creationDate: moment().format('DD/MM/YYYY HH:mm:ss'),
                                        createdBy: userData.username,
                                        type: data.selectedExceptionType.id,
                                        name: data.selectedExceptionType.name
                                    });
                                } else {
                                    this.dialogManagerService.showErrorDialog({
                                        title: translations['ERROR'],
                                        text: translations['ERROR_PACKAGE_EXCEPTION_FAILED_SAVE']
                                    });
                                }
                            }
                        });
                    }
                };
                this.dialogManagerService.showAddExceptionDialog(dialogData, onConfirm);
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: translations['ERROR'],
                    text: translations['ERROR_PACKAGE_EXCEPTION_EMPTY']
                });
            }
        } else {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_USER_AUTH']
            });
        }
    }

    private getExceptionTypes() {
        return [
            { id: 2, name: 'Skip Policy Check' },
            { id: 1, name: 'Skip Pre-Validation' },
            { id: 3, name: 'Skip Post-Validation' },
            { id: 4, name: 'Skip PreCheck' }
        ];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-list/package-exceptions/package-exceptions.component.ts